import useMediaQuery from 'hooks/useMediaQuery';

// Single JS source of truth for the desktop breakpoint. Must match
// $screenlg in src/styles/_breakpoints.sass.
export const DESKTOP_MEDIA_QUERY = '(min-width: 992px)';

const useIsDesktop = () => useMediaQuery(DESKTOP_MEDIA_QUERY);

export default useIsDesktop;
